import {
  checkTimeDuration,
  getTernaryValue,
  getValueOrDefaultObject,
  isEmptyEvery,
  setUpdateCounter,
} from 'common/utilities/utils';
import { getObjectFromLocalStorage } from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SecondaryHeaderItems from '../Presentation/SecondaryHeaderItems';
import { UserOrderContext } from 'context/context';
import { Config } from 'common/constants/SharedConstants';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import DynamicMenuAlertComponent from '../../../../molecules/DynamicMenuAlert/AU/Container/DynamicMenuAlertComponent';
import {
  getUpdateTimeBasedCategory,
  setTimeBasedCategoryAsNotTimeExpired,
} from '../../../../molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';

const SecondaryHeader = props => {
  const { contentData = {}, checkoutHeader } = props;
  const [counter, setCounter] = useState(0);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { timeBasedCetegory } = userOrderState;
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const tenantReducer = useSelector(data => data?.tenantReducer);
  const cartReducer = useSelector(data => data.cartReducer);
  const dispositionNew = getTernaryValue(
    isEmptyEvery(userOrderState.dispositionNew),
    getObjectFromLocalStorage(START_ORDER_CONSTANTS.DISPOSITION_NEW),
    userOrderState.dispositionNew,
  );
  const timeIntervalSec = 15000; // 15sec
  const getClearInterval = useCallback(
    checkTime => {
      return counter ? clearInterval(checkTime) : null;
    },
    [counter],
  );

  useEffect(() => {
    const timer = () => {
      const calculateTimeDiff = checkTimeDuration(
        storeData?.storesWithStatus[0]?.summary,
        Config.STORE_CLOSING_SOON_MODAL_TIMING,
        true,
      );
      getUpdateTimeBasedCategory(timeBasedCetegory, cartReducer, userOrderStateDispatch);
      setTimeBasedCategoryAsNotTimeExpired(timeBasedCetegory, userOrderStateDispatch);
      setUpdateCounter(dispositionNew, cartReducer, calculateTimeDiff, setCounter);
    };
    const checkTime = setInterval(timer, timeIntervalSec);
    getClearInterval(checkTime);
    return () => {
      clearInterval(checkTime);
    };
  }, [
    counter,
    storeData?.storesWithStatus,
    dispositionNew,
    cartReducer?.cartData?.foodLines?.length,
    getClearInterval,
    cartReducer,
    timeBasedCetegory,
    userOrderStateDispatch,
  ]);

  return (
    <div className='secondary-header au' data-testid='HeaderItems-component'>
      <SecondaryHeaderItems
        contentData={contentData}
        checkoutHeader={checkoutHeader}
        tenantReducerData={tenantReducer}
        {...props}
      />
      <DynamicMenuAlertComponent />
    </div>
  );
};

export default SecondaryHeader;
